import React, { useEffect, useMemo, useState } from 'react'
import { Card, CardBody, Container, UncontrolledTooltip } from 'reactstrap';
import Breadcrumbs from "../../components/Common/Breadcrumb";
import TableContainer from 'pages/TodaysUserPerformance/TableContainerTelecallerPerformance';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import axios from 'axios';
//import { getUserListForCallAvailabilityAPIURL } from 'BaseComponentAPI/CallAvailability';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { ToastContainer } from 'react-toastify';
import Spinners from 'components/Common/Spinner';
import PopupWindow from 'components/Common/PopupWindow';
import Loader from 'components/Common/Loader';
import { checkPermissions } from 'components/Common/ChkPermissions';
import CantAccessPage from 'components/Common/CantAccessPage';
import { getTodaysTelecallersPerformanceAPIURL } from 'BaseComponentAPI/TodaysUserPerformanceAPI';

const TodaysTelecallerPerformanceTable = () => {
    const authUser = useSelector(state => state.Login);
    // console.log(JSON.stringify(authUser))

    document.title = "Cockpit";

    const [isPopupVisible, setIsPopupVisible] = useState(false);
    const [popupMessage, setPopupMessage] = useState('');  // Set the message from passed state
    const [popupType, setPopupType] = useState('');  // Set the type from passed state

    const openPopup = (message, type) => {
        setPopupMessage(message);
        setPopupType(type);
        setIsPopupVisible(true);
    };

    const closePopup = () => {
        setIsPopupVisible(false);
    };


    const columns = useMemo(
        () => [
            {
                header: "User Name",
                accessorKey: "userName",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Last disposition",
                accessorKey: "lastDispositionTime",
                enableColumnFilter: false,
                enableSorting: true,
            },

            {
                header: "P. Sys Calls",
                accessorKey: "pendingSysCallCnt",
                enableColumnFilter: false,
                enableSorting: true,
            },

            {
                header: "Leads Processed",
                accessorKey: "liveLeads",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "WO",
                accessorKey: "workOrders",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Lost Leads",
                accessorKey: "lostLeads",
                enableColumnFilter: false,
                enableSorting: true,
            },

            // {
            //     header: "Followups",
            //     accessorKey: "followups",
            //     enableColumnFilter: false,
            //     enableSorting: true,
            // },

            
            {
                header: "Conversion",
                accessorKey: "userConversion",
                enableColumnFilter: false,
                enableSorting: true,
            },
            
            {
                header: "WO Amt",
                accessorKey: "totalWOAmount",
                enableColumnFilter: false,
                enableSorting: true,
            },

            {
                header: "Avg WO Amt",
                accessorKey: "perWOCost",
                enableColumnFilter: false,
                enableSorting: true,
            },

            {
                header: "Contribution",
                accessorKey: "userContribution",
                enableColumnFilter: false,
                enableSorting: true,
            },

            
            
        ],
        []
    );


    const [data, setData] = useState([]);
    const [loaderOption, setLoaderOption] = useState(false);

    const [pageNo, setPageNo] = useState(1);  // Track the current page number
    const [pageSize, setPageSize] = useState(10);  // Track page size
    const [totalPages, setTotalPages] = useState('');
    const [totalItems, setTotalItems] = useState('');
    const [nextPage, setNextPage] = useState('');
    const [previousPage, setPreviousPage] = useState('');
    const [currentPage, setCurrentPage] = useState('');
    const [totalsOfColumn, setTotalOfColumn] = useState({});
    const [totalleads, setTotalLeads] = useState('');
    const [totalWorkOrder, setTotalWorkOrder] = useState('');
    const [totalLost, setTotalLost] = useState('');
    const [totalConversion, setTotalConversion] = useState('');
    const [telecallerPendingCalls, setTelecallerPendingCalls] = useState('');
    
    
    const customePageSize = [10, 20, 30, 40, 50]

    useEffect(() => {
        if (!authUser?.headers || Object.keys(authUser.headers).length === 0) return;

        const fetchData = async () => {
            await getData();
        };

        // Initial API call
        fetchData();

        // Run the interval **only if data is not empty**
        let interval;
        if (data.length > 0) {
            interval = setInterval(fetchData, 180000); // 3 minutes
        }

        return () => {
            if (interval) clearInterval(interval);
        };
    }, [authUser]); // 👈 include data.length dependency


    const getData = async () => {
        setLoaderOption(true);
        setData([]);

        if (authUser.headers && Object.keys(authUser.headers).length > 0) {
            // console.log(JSON.stringify(authUser.headers))
            // console.log(`${getDashboardUserWiseVerificationCallStatsAPIURL}?userUUID=${authUser.headers.userUUID}&isPagination=0&pageNo=0&perPageRec=0`)
            try {
                const response = await axios.get(
                    `${getTodaysTelecallersPerformanceAPIURL}?userUUID=${authUser.headers.userUUID}&isPagination=0&pageNo=0&perPageRec=0`,
                    {
                        headers: { ...authUser.headers },
                        'Authorization': `Bearer ${authUser.headers.access_token}`
                    }
                );

                if (response.data.responseMsg === "Success") {
                    setData(response.data.data.items);
                    setTotalOfColumn(response.data.data.itemsSummary)
                    setTotalLeads(response.data.data.itemsSummary.totalLiveLeads)                    
                    setTotalWorkOrder(response.data.data.itemsSummary.totalWorkOrders)                    
                    setTotalLost(response.data.data.itemsSummary.totalLeadLost)
                    setTotalConversion(response.data.data.itemsSummary.leadConversion)
                    setTelecallerPendingCalls(response.data.data.itemsSummary.telecallerLivePendingCalls)
                    
                    // console.log(response.data.data)

                    setLoaderOption(false);
                }
                else {
                    console.error('API Response Error:', response.data.responseMsg);
                    setLoaderOption(false);
                    openPopup(response.data.responseMsg, 'error')
                }
            } catch (error) {
                console.error('Error fetching data:', JSON.stringify(error));
                setLoaderOption(false);
                openPopup("Requested Data Not Found / 404", 'warn')
            }
            //  finally {
            //     setLoaderOption(false);
            // }
        }
    };

    const handlePageChange = async (newPageNo, newPageSize) => {

    };



    if (loaderOption == true) {
        return (
            <>
                <Loader />
            </>
        )
    }
    else {
        return (
            <React.Fragment>

                {data.length != 0 && (
                    <div className='mt-3'>
                        <h5 className="mt-4" style={{ color: '#b72323' }}>
                            Today's Telecaller Performance Stats
                        </h5>
                        <TableContainer
                            columns={columns}
                            data={data || []}
                            isGlobalFilter={false}
                            isPagination={false}
                            SearchPlaceholder="Search..."
                            isCustomPageSize={false}
                            tableClass="align-middle table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
                            theadClass="table-light"
                            paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                            pagination="pagination"
                            getRowProps={row => ({
                                className: ""
                            })}
                            onPageChange={handlePageChange} // Pass page change handler
                            onPageSizeChange={handlePageChange} // Pass page size change handler
                            pageSize={pageSize}
                            setPageSize={setPageSize}
                            totalPages={totalPages}
                            totalItems={totalItems}
                            tableNextPage={nextPage}
                            tablePreviousPage={previousPage}
                            tableCurrentPage={currentPage}
                            customePageSize={customePageSize}
                            style={{ maxHeight: "300px", overflowY: 'auto' }}
                            totalsOfColumn={totalsOfColumn}
                            totalleads={totalleads}
                            totalWorkOrder={totalWorkOrder}
                            totalLost={totalLost}
                            totalConversion={totalConversion}
                            telecallerPendingCalls = {telecallerPendingCalls}
                             
                        />

                    </div>
                )}

                {isPopupVisible && (
                    <PopupWindow message={popupMessage} type={popupType} onClose={closePopup} />
                )}
            </React.Fragment>
        )
    }
}

TodaysTelecallerPerformanceTable.propTypes = {
    t: PropTypes.any,
};

export default withTranslation()(TodaysTelecallerPerformanceTable);

